import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';

export const Backdrop = styled(Box)`
	height: 100%;
	background: ${tokens.surface.secondary};
`;
